// Filter tools by connection (all or array of ids)

import { McpTool, ConnectionConfig, ToolFilterPreset } from '../types/types';
import { Environment } from '../types/environment';
import { getToolDisplayStatus } from './toolCompletion';
import { ToolDisplayStatus } from '../types/types';

export function filterToolsByStatus(
  tools: McpTool[],
  status: 'all' | ToolDisplayStatus,
  connectors: ConnectionConfig[]
) {
  if (status === 'all') return tools;
  return tools.filter(tool => {
    const con = connectors.find(c => c.id === tool.mainConnectionId);
    return getToolDisplayStatus(tool, !!con?.isActive) === status;
  });
}


export function filterToolsByMethod(tools: McpTool[], method: 'all' | 'get' | 'post' | 'put' | 'delete' | 'patch') {
  return tools.filter(tool => {
    if (method === 'all') return true;
    return tool.httpMethod.toLowerCase() === method;
  });
}

export function filterToolsByEnvironment(tools: McpTool[], environment: Environment | 'all') {
  if (environment === 'all') return tools;
  return tools.filter(tool => tool.environment === environment);
}

export function filterToolsByConnection(tools: McpTool[], connectionIds: string[] | null | undefined) {
  if (!Array.isArray(connectionIds) || connectionIds.length === 0 || connectionIds.includes('all'))
    return tools;
  return tools.filter(tool => tool.mainConnectionId && connectionIds.includes(tool.mainConnectionId));
}

export function filterToolsByActiveConnection(tools: McpTool[], connectors: ConnectionConfig[]) {
  return tools.filter(tool => {
    const connection = connectors.find(c => c.id === tool.mainConnectionId);
    return !!connection?.isActive;
  });
}

const normalizeConnections = (ids: string[] | null | undefined) =>
  !ids || ids.length === 0 || ids.includes('all') ? ['all'] : [...ids].sort();

const sameList = (a: string[], b: string[]) =>
  a.length === b.length && a.every((v, i) => v === b[i]);

export function matchesPresetFilters(current: Required<ToolFilterPreset['filters']>, preset: ToolFilterPreset['filters']) {
  return (preset.statusFilter ?? 'all') === current.statusFilter
    && (preset.methodFilter ?? 'all') === current.methodFilter
    && (preset.environmentFilter ?? 'all') === current.environmentFilter
    && (preset.searchTerm ?? '') === current.searchTerm
    && (preset.sortBy ?? 'updated_at') === current.sortBy
    && sameList(normalizeConnections(preset.connectionFilter), normalizeConnections(current.connectionFilter))
    && sameList([...(preset.selectedTags ?? [])].sort(), [...current.selectedTags].sort());
}

export function sortTools(tools: McpTool[], direction: 'asc' | 'desc') {
  return [...tools].sort((a, b) => {
    const cmp = a.name.localeCompare(b.name);
    return direction === 'asc' ? cmp : -cmp;
  });
}